import * as Yup from "yup";

export default Yup.object().shape({
    sizeId: Yup.number().nullable().required("Please select a size"),
    quantity: Yup.number().moreThan(0, "Please select a valid number").nullable().required("Please select quantity"),
    matStyleId: Yup.number().nullable().required("Please select mat style")
});
